import * as Types from '../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetJsInterviewPrepResumeImprovementsQueryVariables = Types.Exact<{
  input: Types.GetJsInterviewPrepResumeImprovementsInput;
}>;


export type GetJsInterviewPrepResumeImprovementsQuery = { __typename?: 'Query', getJsInterviewPrepResumeImprovements?: { __typename?: 'GetJsInterviewPrepResumeImprovementsPayload', extractionId: string, interviewId?: string | null, jobKey?: string | null, status: Types.JsInterviewPrepResumeImprovementsStatus, extractedAt?: string | null, pendingImprovementCount?: number | null, resume?: { __typename?: 'JsInterviewPrepResumeImprovements', resumeId?: string | null, workExperiences: Array<{ __typename?: 'JsInterviewPrepWorkExperienceImprovement', improvementId: string, id: string, title?: string | null, description?: string | null, status: Types.JsInterviewPrepResumeImprovementStatus, dateRange?: { __typename?: 'JsInterviewResumeImprovementsDateRange', isCurrent?: boolean | null, fromDate?: { __typename?: 'JsInterviewResumeImprovementsDateType', year?: number | null } | null, toDate?: { __typename?: 'JsInterviewResumeImprovementsDateType', year?: number | null } | null } | null } | null>, certifications: Array<{ __typename?: 'JsInterviewPrepCertificationImprovement', improvementId: string, id?: string | null, title?: string | null, description?: string | null, status: Types.JsInterviewPrepResumeImprovementStatus, dateRange?: { __typename?: 'JsInterviewResumeImprovementsDateRange', isCurrent?: boolean | null, fromDate?: { __typename?: 'JsInterviewResumeImprovementsDateType', year?: number | null } | null, toDate?: { __typename?: 'JsInterviewResumeImprovementsDateType', year?: number | null } | null } | null } | null>, licenses: Array<{ __typename?: 'JsInterviewPrepLicenseImprovement', improvementId: string, id?: string | null, title?: string | null, status: Types.JsInterviewPrepResumeImprovementStatus, dateRange?: { __typename?: 'JsInterviewResumeImprovementsDateRange', isCurrent?: boolean | null, fromDate?: { __typename?: 'JsInterviewResumeImprovementsDateType', year?: number | null } | null, toDate?: { __typename?: 'JsInterviewResumeImprovementsDateType', year?: number | null } | null } | null } | null>, languages: Array<{ __typename?: 'JsInterviewPrepLanguageImprovement', improvementId: string, id?: string | null, title?: string | null, proficiency?: string | null, status: Types.JsInterviewPrepResumeImprovementStatus } | null>, skills: Array<{ __typename?: 'JsInterviewPrepSkillImprovement', improvementId: string, text?: string | null, status: Types.JsInterviewPrepResumeImprovementStatus } | null> } | null } | null };


export const GetJsInterviewPrepResumeImprovementsDocument = gql`
    query GetJsInterviewPrepResumeImprovements($input: GetJsInterviewPrepResumeImprovementsInput!) {
  getJsInterviewPrepResumeImprovements(input: $input) {
    extractionId
    interviewId
    jobKey
    status
    extractedAt
    pendingImprovementCount
    resume {
      resumeId
      workExperiences {
        improvementId
        id
        title
        description
        dateRange {
          fromDate {
            year
          }
          toDate {
            year
          }
          isCurrent
        }
        status
      }
      certifications {
        improvementId
        id
        title
        description
        dateRange {
          fromDate {
            year
          }
          toDate {
            year
          }
          isCurrent
        }
        status
      }
      licenses {
        improvementId
        id
        title
        dateRange {
          fromDate {
            year
          }
          toDate {
            year
          }
          isCurrent
        }
        status
      }
      languages {
        improvementId
        id
        title
        proficiency
        status
      }
      skills {
        improvementId
        text
        status
      }
    }
  }
}
    `;

/**
 * __useGetJsInterviewPrepResumeImprovementsQuery__
 *
 * To run a query within a React component, call `useGetJsInterviewPrepResumeImprovementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJsInterviewPrepResumeImprovementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJsInterviewPrepResumeImprovementsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetJsInterviewPrepResumeImprovementsQuery(baseOptions: Apollo.QueryHookOptions<GetJsInterviewPrepResumeImprovementsQuery, GetJsInterviewPrepResumeImprovementsQueryVariables> & ({ variables: GetJsInterviewPrepResumeImprovementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJsInterviewPrepResumeImprovementsQuery, GetJsInterviewPrepResumeImprovementsQueryVariables>(GetJsInterviewPrepResumeImprovementsDocument, options);
      }
export function useGetJsInterviewPrepResumeImprovementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJsInterviewPrepResumeImprovementsQuery, GetJsInterviewPrepResumeImprovementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJsInterviewPrepResumeImprovementsQuery, GetJsInterviewPrepResumeImprovementsQueryVariables>(GetJsInterviewPrepResumeImprovementsDocument, options);
        }
export function useGetJsInterviewPrepResumeImprovementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJsInterviewPrepResumeImprovementsQuery, GetJsInterviewPrepResumeImprovementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJsInterviewPrepResumeImprovementsQuery, GetJsInterviewPrepResumeImprovementsQueryVariables>(GetJsInterviewPrepResumeImprovementsDocument, options);
        }
export type GetJsInterviewPrepResumeImprovementsQueryHookResult = ReturnType<typeof useGetJsInterviewPrepResumeImprovementsQuery>;
export type GetJsInterviewPrepResumeImprovementsLazyQueryHookResult = ReturnType<typeof useGetJsInterviewPrepResumeImprovementsLazyQuery>;
export type GetJsInterviewPrepResumeImprovementsSuspenseQueryHookResult = ReturnType<typeof useGetJsInterviewPrepResumeImprovementsSuspenseQuery>;
export type GetJsInterviewPrepResumeImprovementsQueryResult = Apollo.QueryResult<GetJsInterviewPrepResumeImprovementsQuery, GetJsInterviewPrepResumeImprovementsQueryVariables>;